<template>
    <span :class="`${statusClass} additionalClass`">{{ content }}</span>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            required: true
        },
        status: {
            required: true
        }
    },

    computed: {
        statusClass() {
            const statusNumberMap = {
                1: 'active',
                0: 'inactive',
                '-1': 'deleted',
                2: 'dissolved',
                6: 'six'
            }
            const statusStringMap = {
                1: 'active',
                0: 'inactive',
                '-1': 'deleted',
                2: 'dissolved',
                6: 'six'
            }

            return typeof this.status === 'number'
                ? statusNumberMap[this.status] || ''
                : typeof this.status === 'string'
                ? statusStringMap[this.status] || ''
                : ''
        }
    }
}
</script>

<style scoped>
.active {
    background-color: #28A74533;
    color: #28A745 !important;
}
.inactive {
    background-color: #e4e5e6;
    color: #303133 !important;
}
.deleted {
    background-color: #f3cccc;
    color: #FF5252 !important;
}
.dissolved {
    background-color: #faf1c7;
    color: #FF5252 !important;
}
.six {
    background-color: #ffc8aa;
    color: #FF5252 !important;
}
.additionalClass {
    border-radius: 1rem;
    padding: 0.25rem 0.5rem;
}
</style>
